import PercentageItem from '@op/components/Snippets/PercentageItem';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import SmallChart from '@op/pages/Summary/components/SmallChart';
import { formatSameDayFunc } from '@op/utils/time';
import { reviewsFormat } from '@op/utils/value';
import React, { useMemo } from 'react';
import { Progress } from 'tea-component';
import TableProgress from '@op/components/Snippets/TableProgress';

function getTheme(value: number) {
  if (value > 3.5) return '#29B569';
  if (value >= 2.5) return '#838697';
  return '#EF5858';
}

/**
 * 获取一个带环比 + 图表(可选) 的表格列
 * @param data       表格数据
 * @param valueKey   数值key
 *         `${valueKey}_qoq`  环比key
 *         `${valueKey}_old`  老值key
 *         newTimes           环比新时间
 *         oldTimes           环比老时间
 * @param filter     过滤器数据
 * @param timeline   小图表数据
 * @param formatValue 格式化方法
 * @param header      小图标展示标题
 * @param name        图表左侧展示文案
 * @returns
 */
export default function PercentRatioOrChart({
  data,
  valueKey,
  filter,
  timeline,
  formatValue = reviewsFormat,
  header,
  name,
  isSentiment,
  tableProgress,
}: {
  data: any;
  valueKey: string;
  filter: any;
  timeline: any;
  formatValue: any;
  header: string;
  name: string;
  isSentiment?: boolean;
  tableProgress?: boolean;
}) {
  const { x, y } = timeline || { x: [], y: [] };
  const [value, qoqValue, oldValue, newTime, oldTime] = useMemo(() => {
    const qoqKey = valueKey + '_qoq';
    const oldKey = valueKey + '_old';

    return [valueKey, qoqKey, oldKey, 'newTimes', 'oldTimes'].map((key) => {
      return data[key];
    }, {});
  }, []);

  const empty = useMemo(() => {
    return x.length === 0 && y.length === 0;
  }, [x, y]);

  const element = (
    <>
      <div className="dbo-topic-tracking-table-info">
        <div className="dbo-topic-tracking-table-info-percent">
          <div className="item-info">
            {formatValue(value)}
            <RingRatioBubble
              newTime={newTime}
              oldTime={oldTime}
              oldValue={oldValue}
              newValue={value}
              formateValue={formatValue}
              formateDate={formatSameDayFunc(filter)}
            >
              <PercentageItem percentage={qoqValue}></PercentageItem>
            </RingRatioBubble>
          </div>
        </div>
        <div className="dbo-topic-tracking-table-info-chart">
          {!empty && (
            <SmallChart
              text={header}
              statistics={{ x, y }}
              name={name}
              formatValueFunc={(value: number) => formatValue(value)}
              dateType={filter.date_type}
            />
          )}
        </div>
      </div>
      {isSentiment && (
        <Progress
          className="dbo-progress-box"
          percent={(value / 5) * 100}
          strokeWidth={4}
          strokeColor={getTheme(value)}
        />
      )}
    </>
  );

  if (tableProgress) {
    return <TableProgress percent={value}>{element}</TableProgress>;
  }

  return element;
}
